import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=210f5306&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
import style0 from "./Test.vue?vue&type=style&index=0&id=210f5306&prod&scoped=true&lang=css"
import style1 from "./Test.vue?vue&type=style&index=1&id=210f5306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f5306",
  null
  
)

export default component.exports